import { ROLE_IDS } from "../../../../constants/roles.ts"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import {
  selectActiveBranch,
  selectActiveBranchId,
  selectCompanyIsMultiBranch,
  selectIsOwner
} from "../../../Branches/redux/branches.slice.ts"
import { type PermissionFeatures } from "../../../SettingsPermissions/types/permissions.types.ts"

export const COMPANY_DEFAULTS_SUBTABS = [
  { key: RoutesPaths.settings.configuration, label: "Configurations" },
  {
    key: RoutesPaths.settings.formFieldRequirements,
    label: "Required Information"
  },
  { key: RoutesPaths.settings.templates, label: "Templates" }
]

// The same rule as the Configurations route gate: the legacy role id alone
// misses a GCC Admin granted through a permission label, so the tab must not
// open on Configurations for them (it renders nothing).
export function useCanManageConfiguration() {
  const roleId = useAppSelector((state) => state.auth?.userInfo?.role?.id)
  const isOwner = useAppSelector(selectIsOwner)
  const isMultiBranch = useAppSelector(selectCompanyIsMultiBranch)
  const activeBranchId = useAppSelector(selectActiveBranchId)
  const isActiveBranchManager = !!useAppSelector(selectActiveBranch)?.is_manager
  return (
    isOwner ||
    roleId === ROLE_IDS.ADMIN_GCC ||
    roleId === ROLE_IDS.ADMIN_PLATFORM ||
    (isMultiBranch && !!activeBranchId && isActiveBranchManager)
  )
}

export function companyDefaultsSubtabsFor(
  permissions: PermissionFeatures | undefined,
  canManageConfiguration: boolean
) {
  const settings = permissions?.settings
  const allowed: Record<string, boolean> = {
    [RoutesPaths.settings.configuration]: canManageConfiguration,
    [RoutesPaths.settings.formFieldRequirements]:
      !!settings?.form_requirements?.form_requirements_manage,
    [RoutesPaths.settings.templates]: !!(
      settings?.project_templates?.settings_template_view ||
      settings?.document_templates?.settings_proposal_template_view ||
      settings?.permissions?.settings_permissions_view ||
      settings?.email_templates?.settings_email_template_view
    )
  }
  return COMPANY_DEFAULTS_SUBTABS.filter(({ key }) => allowed[key])
}

export function useCompanyDefaultsSubtabs() {
  const permissions = useAppSelector(
    (state) => state.auth?.userInfo?.permissions?.codes
  )
  return companyDefaultsSubtabsFor(permissions, useCanManageConfiguration())
}
